import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { JunctionMovementCountsCard } from "./JunctionMovementCountsCard";
import { JunctionMovementDetailCard } from "./JunctionMovementDetailCard";
import { buildJunctionMovementRows, JunctionMovementCounts } from "./junctionMovementRows";
export const JunctionMovementCards = t0 => {
  const $ = _c(17);
  const {
    data,
    selectedMovementId,
    onSelectMovement,
    onClose
  } = t0;
  let t1;
  if ($[0] !== data.counts || $[1] !== data.movements) {
    t1 = buildJunctionMovementRows(data.counts, data.movements);
    $[0] = data.counts;
    $[1] = data.movements;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rows = t1;
  let t2;
  if ($[3] !== rows || $[4] !== selectedMovementId) {
    t2 = selectedMovementId === null ? null : rows.find(row => row.movement.id === selectedMovementId);
    $[3] = rows;
    $[4] = selectedMovementId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const selectedRow = t2;
  if (!selectedRow) {
    let t3;
    if ($[6] !== data.junction.label || $[7] !== onClose || $[8] !== onSelectMovement || $[9] !== rows) {
      t3 = <JunctionMovementCountsCard junctionLabel={data.junction.label} rows={rows} onMovementSelect={onSelectMovement} onClose={onClose} />;
      $[6] = data.junction.label;
      $[7] = onClose;
      $[8] = onSelectMovement;
      $[9] = rows;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  let t3;
  if ($[11] !== onSelectMovement) {
    t3 = () => onSelectMovement(null);
    $[11] = onSelectMovement;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== data.junction.label || $[14] !== selectedRow || $[15] !== t3) {
    t4 = <JunctionMovementDetailCard junctionLabel={data.junction.label} row={selectedRow} onBack={t3} />;
    $[13] = data.junction.label;
    $[14] = selectedRow;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};